/* eslint-disable import/prefer-default-export */

/**
 * Always persist include_images as an explicit boolean (default true).
 */
export const retrieveProductsArgs = (includeImages = true) => (
  [{ include_images: includeImages !== false }]
);

/**
 * Default ON when missing / empty / true. OFF only for explicit false.
 */
export const readIncludeImagesFromToolArgs = (args) => {
  if (!Array.isArray(args) || args.length === 0) return true;
  const args0 = args[0] || {};
  return args0.include_images !== false && args0.include_images !== 'false';
};
